// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareHeadingItem-24k26";
var _3 = "fareHeadingItem_isKey-HtPNi";
var _4 = "fareHeadingItem__title-17DBf";
export { _1 as "__esModule", _2 as "fareHeadingItem", _3 as "fareHeadingItem_isKey", _4 as "fareHeadingItem__title" }
export default { "__esModule": _1, "fareHeadingItem": _2, "fareHeadingItem_isKey": _3, "fareHeadingItem__title": _4 }
